export default __webpack_public_path__ + "static/media/loading.2a20067a.gif";